import { render, staticRenderFns } from "./HistoryLocation.vue?vue&type=template&id=71a85832&"
import script from "./HistoryLocation.vue?vue&type=script&lang=js&"
export * from "./HistoryLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports